import { createSelector } from "reselect";

import { RootState } from "../../rootReducer";

export const selectUserProfileLocationFilters = createSelector(
  [(store: RootState) => store.userProfileLocation.createFilters],
  (data) => data
);